import React from 'react';
import PropTypes from 'prop-types';
import ValueProps from '../ValueProps';
import cnames from 'classnames';

import './Jumbotron.less';
import { Experiment } from '../Experiment';

const CNAME = 'Jumbotron';

const Jumbotron = ({ children, showValueProps }) => (
  <div className={CNAME}>
    <Experiment name="HA_PTA_HP_NewValueProps">
      {(value, experiment) =>
        (
          <div className={cnames('Jumbotron__wrapper', {
            'Jumbotron__wrapper--new-value-props': experiment && value === 1
          })}
          >
            <div className={`${CNAME}__content`}>
              {children}
            </div>
            { (value === 0 || value === null) && showValueProps && <ValueProps /> }
          </div>
        )}
    </Experiment>
  </div>
);

Jumbotron.propTypes = {
  showValueProps: PropTypes.bool.isRequired
};

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/universal/components/Jumbotron/Jumbotron.js